import Vue from 'vue'

const mutations = {

  /**
   * @param state
   * @param network
   */
  SET_NETWORKLIST (state, networks) {
    Vue.set(state, 'network_list', networks)
  },
  SET_CURRENTCLIENT (state, currentClient) {
    state.client_selected = currentClient
  },

  ADD_NETWORK (state, network) {
    state.network_list.push(network)
  },

  ADD_NETWORK_TO_NETWORKLIST (state, networkData) {
    state.network_list.push(networkData)
  },

  UPDATE_NETWORK_IN_NETWORKLIST (state, networkData) {
    let updatedNetworkIndex = state.network_list.findIndex(oldNetwork => oldNetwork.id === networkData.id)
    if (updatedNetworkIndex !== -1) {
      Vue.set(state.network_list, updatedNetworkIndex, networkData)
    }
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/network/network.mutations.js
// module id = null
// module chunks = 